// TODO XJU - à refactoré pour tout passer dans le micro-front-articles
import { articleUseCase } from '@b2ag/micro-front-articles/dependency-injection'
import type { ArticleThumbnails } from '@b2ag/micro-front-articles/types'
import type { Home } from '../Home'
import type { IHomeRepository } from '../repository/IHomeRepository'

export class HomeUseCase {
  constructor(private iHomeRepository: IHomeRepository) {}

  async getHome(): Promise<Home> {
    const home = await this.iHomeRepository.getHome()
    const articlesFilteredByPartner = await articleUseCase.getArticles(home.pushArticles!)
    const homePushArticle = { ...home.pushArticles, articles: articlesFilteredByPartner } as ArticleThumbnails
    return { ...home, pushArticles: homePushArticle }
  }

  async getPartnerHome(partnerId: string, frontContext: string, segmentTags: string[]): Promise<Home | null> {
    const { iHomeRepository } = this
    const frontEnd = frontContext.toLowerCase() === 'agri' ? 'Agri' : 'Tech'
    const home = await iHomeRepository.getPartnerHome(partnerId, frontEnd, segmentTags)
    if (!home) {
      return null
    }
    return Promise.all([
      articleUseCase.getFilteredArticlesBySegment(
        home.pushArticles as ArticleThumbnails,
        true,
        +partnerId,
        undefined,
        segmentTags,
      ),
      iHomeRepository.getPartnerHomeBanner(partnerId),
    ]).then(async ([filteredArticles, homeBanner]) => {
      if (homeBanner) {
        home.partnerHomeBanner = homeBanner
      }
      if (home.pushArticles?.articles) {
        const homePushArticle = {
          ...home.pushArticles,
          articles: filteredArticles,
        } as ArticleThumbnails
        return { ...home, pushArticles: homePushArticle }
      }
      return home
    })
  }
}
